import { Stack } from '@chakra-ui/react';
import React from 'react';

import { ChallengeWidget } from 'features/chat/components/ChatMessages/ChatMessage/Widgets/ChallengeWidget';
import { GenericWidget } from 'features/chat/components/ChatMessages/ChatMessage/Widgets/GenericWidget';
import { GoalWidget } from 'features/chat/components/ChatMessages/ChatMessage/Widgets/GoalWidget';
import { JournalWidget } from 'features/chat/components/ChatMessages/ChatMessage/Widgets/JournalWidget';
import { SprintWidget } from 'features/chat/components/ChatMessages/ChatMessage/Widgets/SprintWidget';
import { Widget } from 'features/chat/config/types/Message';

import { getWidgetMeta } from './Widgets/widgetMeta';

type ChatMessageWidgetsProps = {
  widgets: Widget[];
};

type WidgetRendererProps = {
  widget: Widget;
};

export const ChatMessageWidgets = ({ widgets }: ChatMessageWidgetsProps) => {
  if (!widgets || widgets.length === 0) {
    return null;
  }

  return (
    <Stack gap="8px" width="100%">
      {widgets.map((widget) => (
        <WidgetRenderer key={widget.id} widget={widget} />
      ))}
    </Stack>
  );
};

const WidgetRenderer = ({ widget }: WidgetRendererProps) => {
  const meta = getWidgetMeta(widget);

  switch (meta.category) {
    case 'challenge':
      return <ChallengeWidget widget={widget} meta={meta} />;
    case 'goal':
      return <GoalWidget widget={widget} meta={meta} />;
    case 'sprint':
      return <SprintWidget widget={widget} meta={meta} />;
    case 'journal':
      return <JournalWidget widget={widget} meta={meta} />;
    default:
      return <GenericWidget widget={widget} meta={meta} />;
  }
};
